import React from "react";
import { LoadSpinner } from "@monorepo/load-spinner";
import { Layout } from "../layout";
import { SpinnerContainer } from "../layout/styles";

export const Fallback = () => {
    return (
        <Layout>
            <SpinnerContainer>
                <LoadSpinner />
            </SpinnerContainer>
        </Layout>
    );
};
